import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import React from 'react';

import { ShieldLockIcon } from '../../icons';

type Props = {
  sx?: SxProps;
};

const StoreInfoSecurelyNote: React.FC<Props> = ({ sx }: Props) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" color="secure.main" sx={sx}>
      <ShieldLockIcon />
      <Typography variant="caption" sx={{ ml: 1 }}>
        We securely store and encrypt your personal information
      </Typography>
    </Box>
  );
};

export { StoreInfoSecurelyNote };
